import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./Settings.css";

const Settings = () => {
  const [companyInfo, setCompanyInfo] = useState({
    companyName: "",
    logoUrl: ""
  });
  const [templates, setTemplates] = useState([]);
  const [newTemplate, setNewTemplate] = useState({
    templateName: "",
    templateContent: `Proposal for: {{siteName}}
Management: {{management}}
Manager Name: {{managerName}}
Address: {{address}}
City, State, Zip: {{cityStateZip}}
Scope: {{scope}}
Job Description: {{jobDescription}}
Option A Price: {{optionAprice}}
Option B Price: {{optionBprice}}
Option C Price: {{optionCprice}}
Submitted Date: {{submittedDate}}
Terms: {{terms}}`
  });
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyInfoRef = doc(db, "settings", "companyInfo");
        const companyInfoDoc = await getDoc(companyInfoRef);
        if (companyInfoDoc.exists()) {
          setCompanyInfo(companyInfoDoc.data());
        }

        const templatesRef = collection(db, "templates");
        const templatesSnapshot = await getDocs(templatesRef);
        const templatesList = templatesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTemplates(templatesList);
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  const handleCompanyInfoChange = (e) => {
    const { name, value } = e.target;
    setCompanyInfo(prev => ({ ...prev, [name]: value }));
  };

  const handleTemplateChange = (e) => {
    const { name, value } = e.target;
    setNewTemplate(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveCompanyInfo = async () => {
    try {
      const companyInfoRef = doc(db, "settings", "companyInfo");
      await updateDoc(companyInfoRef, companyInfo);
      alert("Company information saved successfully!");
    } catch (error) {
      console.error("Error saving company information:", error);
    }
  };

  const handleAddTemplate = async () => {
    try {
      await addDoc(collection(db, "templates"), newTemplate);
      setTemplates([...templates, newTemplate]);
      setNewTemplate({ templateName: "", templateContent: "" });
      alert("Template added successfully!");
    } catch (error) {
      console.error("Error adding template:", error);
    }
  };

  const handleEditTemplate = (template) => {
    setSelectedTemplate(template);
    setNewTemplate(template);
  };

  const handleSaveTemplate = async () => {
    try {
      const templateRef = doc(db, "templates", selectedTemplate.id);
      await updateDoc(templateRef, newTemplate);
      setTemplates(templates.map(template => template.id === selectedTemplate.id ? newTemplate : template));
      setSelectedTemplate(null);
      setNewTemplate({ templateName: "", templateContent: "" });
      alert("Template saved successfully!");
    } catch (error) {
      console.error("Error saving template:", error);
    }
  };

  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <div className="company-info">
        <h2>Company Information</h2>
        <label>Company Name:</label>
        <input type="text" name="companyName" value={companyInfo.companyName} onChange={handleCompanyInfoChange} />
        <label>Logo URL:</label>
        <input type="text" name="logoUrl" value={companyInfo.logoUrl} onChange={handleCompanyInfoChange} />
        <button className="blue-button" onClick={handleSaveCompanyInfo}>Save</button>
      </div>
      <div className="templates">
        <h2>Proposal Templates</h2>
        <div className="template-form">
          <label>Template Name:</label>
          <input type="text" name="templateName" value={newTemplate.templateName} onChange={handleTemplateChange} />
          <label>Template Content:</label>
          <textarea name="templateContent" value={newTemplate.templateContent} onChange={handleTemplateChange}></textarea>
          {selectedTemplate ? (
            <div className="modal-buttons">
              <button className="blue-button" onClick={handleSaveTemplate}>Save</button>
              <button className="red-button" onClick={() => setSelectedTemplate(null)}>Cancel</button>
            </div>
          ) : (
            <button className="blue-button" onClick={handleAddTemplate}>Add Template</button>
          )}
        </div>
        <div className="template-list">
          <h3>Existing Templates</h3>
          {templates.map(template => (
            <div key={template.id} className="template-item">
              <h4>{template.templateName}</h4>
              <button className="blue-button" onClick={() => handleEditTemplate(template)}>Edit</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Settings;